import axios from 'axios';

const API_URL = '/api';  // nginx проксирует /api/ → vk_app:8000

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const authUser = async (vkUserId, accessToken, userInfo = {}, launchParams = null) => {
  const payload = {
    vk_user_id: vkUserId,
    access_token: accessToken,
    first_name: userInfo.first_name,
    last_name: userInfo.last_name,
    photo_url: userInfo.photo_100 || userInfo.photo_url,
  };
  if (launchParams) {
    payload.launch_params = launchParams;
  }
  const response = await api.post('/auth', payload);
  return response.data;
};

export const getCharacters = async () => {
  const response = await api.get('/characters');
  return response.data;
};

export const sendMessage = async (launchParams, characterId, message, conversationId = null, missionNum = null, slotId = 0, requestId = null) => {
  const payload = {
    launch_params: launchParams,
    character_id: characterId,
    message: message,
    request_id: requestId || `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
    slot_id: slotId,
  };
  if (missionNum) {
    payload.mission_num = missionNum;
  }
  const response = await api.post('/chat', payload, {
    timeout: 460000, // чуть больше серверного лимита 7,5 минуты
  });
  return response.data;
};

export const getProfile = async (vkUserId, launchParams) => {
  const response = await api.get(`/profile/${vkUserId}`, {
    params: { launch_params: launchParams }
  });
  return response.data;
};

export const selectCharacter = async (launchParams, characterId, username, missionNum = null, userDescription = '', slotId = 0) => {
  const payload = {
    launch_params: launchParams,
    character_id: characterId,
    username: username,
    slot_id: slotId,
  };
  if (userDescription) {
    payload.user_description = userDescription;
  }
  if (missionNum) {
    payload.mission_num = missionNum;
  }
  const response = await api.post('/select_character', payload);
  return response.data;
};

export const updateUserState = async (launchParams, state) => {
  const response = await api.post('/update_state', {
    launch_params: launchParams,
    state: state,
  });
  return response.data;
};

export const checkSession = async (launchParams, characterId, slotId = 0) => {
  const response = await api.post('/check_session', {
    launch_params: launchParams,
    character_id: characterId,
    slot_id: slotId,
  });
  return response.data;
};

export const getRoleplayRules = async (target) => {
  const response = await api.post('/roleplay_rules/read', target);
  return response.data;
};

export const saveRoleplayRules = async (target, rules) => {
  const response = await api.post('/roleplay_rules', { ...target, roleplay_rules: rules });
  return response.data;
};

export const getChatHistory = async (vkUserId, characterId, launchParams, missionNum = null, slotId = 0) => {
  const params = { launch_params: launchParams, slot_id: slotId };
  if (missionNum) {
    params.mission_num = missionNum;
  }
  const response = await api.get(`/history/${vkUserId}/${characterId}`, { params });
  return response.data;
};

export const initMission = async (launchParams, characterId, missionNum, username, msgWorld, msgAgent) => {
  const response = await api.post('/init_mission', {
    launch_params: launchParams,
    character_id: characterId,
    mission_num: missionNum,
    username: username,
    msg_world: msgWorld,
    msg_agent: msgAgent,
  });
  return response.data;
};

export const getPaymentItems = async (launchParams = null) => {
  const config = {};
  if (launchParams) {
    config.params = { launch_params: launchParams };
  }
  const response = await api.get('/payment_items', config);
  return response.data;
};

export const getSubscriptions = async () => {
  const response = await api.get('/subscriptions');
  return response.data;
};

export const claimDailyBonus = async (launchParams) => {
  const response = await api.post('/claim_daily_bonus', {
    launch_params: launchParams,
  });
  return response.data;
};

export const getReferralInfo = async (vkUserId, launchParams) => {
  const response = await api.get('/referral_info', {
    params: { vk_user_id: vkUserId, launch_params: launchParams }
  });
  return response.data;
};

export const activateReferral = async (launchParams, refCode) => {
  const response = await api.post('/referral_activate', {
    launch_params: launchParams,
    ref_code: refCode,
  });
  return response.data;
};

export const shareReferral = async (launchParams) => {
  const response = await api.post('/referral_share', {
    launch_params: launchParams,
  });
  return response.data;
};

export const enableNotifications = async (launchParams) => {
  const response = await api.post('/enable_notifications', {
    launch_params: launchParams,
  });
  return response.data;
};

export const resetDialog = async (launchParams, characterId, missionNum = null, slotId = 0, requestId = null) => {
  const payload = { launch_params: launchParams, character_id: characterId, slot_id: slotId };
  if (missionNum) payload.mission_num = missionNum;
  if (requestId) payload.request_id = requestId;
  const response = await api.post('/reset_dialog', payload);
  return response.data;
};

export const undoLast = async (launchParams, characterId, missionNum = null, slotId = 0, requestId = null) => {
  const payload = {
    launch_params: launchParams,
    character_id: characterId,
    slot_id: slotId,
  };
  if (missionNum) {
    payload.mission_num = missionNum;
  }
  if (requestId) payload.request_id = requestId;
  const response = await api.post('/undo_last', payload);
  return response.data;
};

export const getSharedWorldStatus = async (launchParams) => {
  const response = await api.post('/shared_world/status', {
    launch_params: launchParams,
  });
  return response.data;
};

export const enterSharedWorld = async (
  launchParams,
  characterId,
  username,
  userDescription = '',
  eventId = null,
) => {
  const payload = {
    launch_params: launchParams,
    character_id: characterId,
    username,
    user_description: userDescription,
  };
  if (eventId) payload.event_id = eventId;
  const response = await api.post('/shared_world/enter', payload, {
    timeout: 60000,
  });
  return response.data;
};

export const acknowledgeSharedWorldNotification = async (
  launchParams,
  notificationId,
) => {
  const response = await api.post(
    `/shared_world/notifications/${encodeURIComponent(notificationId)}/ack`,
    { launch_params: launchParams },
  );
  return response.data;
};

export const leaveSharedWorldEvent = async (launchParams, eventId) => {
  const response = await api.post(
    `/shared_world/events/${encodeURIComponent(eventId)}/leave`,
    { launch_params: launchParams },
    { timeout: 60000 },
  );
  return response.data;
};

export const getCharacterSlots = async (launchParams, characterId) => {
  const response = await api.post('/character_slots/list', {
    launch_params: launchParams,
    character_id: characterId,
  });
  return response.data;
};

export const getCustomCharacters = async (launchParams) => {
  const response = await api.post('/custom_characters/list', {
    launch_params: launchParams,
  });
  return response.data;
};

export const getCustomCharacter = async (launchParams, characterId) => {
  const response = await api.post('/custom_characters/get', {
    launch_params: launchParams,
    character_id: characterId,
  });
  return response.data;
};

export const createCustomCharacter = async (launchParams, character) => {
  const response = await api.post('/custom_characters/create', {
    launch_params: launchParams,
    display_name: character.displayName,
    system_prompt: character.systemPrompt,
    difficulty_key: character.difficultyKey,
  });
  return response.data;
};

export const updateCustomCharacter = async (launchParams, characterId, character) => {
  const response = await api.post('/custom_characters/update', {
    launch_params: launchParams,
    character_id: characterId,
    display_name: character.displayName,
    system_prompt: character.systemPrompt,
    difficulty_key: character.difficultyKey,
  });
  return response.data;
};

export const deleteCustomCharacter = async (launchParams, characterId) => {
  const response = await api.post('/custom_characters/delete', {
    launch_params: launchParams,
    character_id: characterId,
  });
  return response.data;
};

export const createCharacterSlot = async (launchParams, characterId) => {
  const response = await api.post('/character_slots/create', {
    launch_params: launchParams,
    character_id: characterId,
  });
  return response.data;
};

export const selectCharacterSlot = async (launchParams, characterId, slotId) => {
  const response = await api.post('/character_slots/select', {
    launch_params: launchParams,
    character_id: characterId,
    slot_id: slotId,
  });
  return response.data;
};

export const renameCharacterSlot = async (launchParams, characterId, slotId, title) => {
  const response = await api.post('/character_slots/rename', {
    launch_params: launchParams,
    character_id: characterId,
    slot_id: slotId,
    title,
  });
  return response.data;
};

export const deleteCharacterSlot = async (launchParams, characterId, slotId) => {
  const response = await api.post('/character_slots/delete', {
    launch_params: launchParams,
    character_id: characterId,
    slot_id: slotId,
  });
  return response.data;
};

export const deleteUser = async (launchParams) => {
  const response = await api.post('/delete_user', {
    launch_params: launchParams,
  });
  return response.data;
};

export const confirmAccess = async (launchParams) => {
  const response = await api.post('/confirm_access', {
    launch_params: launchParams,
  });
  return response.data;
};

export default api;
